<template>
  <v-footer
    color="white"
    class="py-12 py-md-16"
    style="border-top: 1px solid #e0e0e0"
  >
    <v-container>
      <v-row>
        <v-col cols="12" md="4" class="mb-8 mb-md-0 pr-md-8">
          <v-img
            src="@/assets/icons/OhYesMainLogo.png"
            alt="Oh Yes Corp Logo"
            contain
            height="45"
            class="logo-img mb-6"
            style="max-width: 150px"
          ></v-img>

          <p class="footer-text tagline-text">
            OH YES is a digital platform where hundreds of services come
            together. We act as a service provider hub for customers.
          </p>
          <div class="mt-6 mb-4">
            <v-btn
              icon
              class="mr-3 social-icon-btn"
              v-for="social in socials"
              :key="social.icon"
              :href="social.link"
              target="_blank"
              rel="noopener noreferrer"
              small
            >
              <v-icon size="20">{{ social.icon }}</v-icon>
            </v-btn>
          </div>

          <div class="d-flex align-center app-buttons mt-4">
            <v-btn
              color="#f46523"
              small
              dark
              class="text-capitalize font-weight-bold mr-3 app-btn-style"
              href="https://play.google.com/store/apps/details?id=com.ohyes.app&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-icon left>mdi-google-play</v-icon>
              Google Play
            </v-btn>

            <v-btn
              color="#f46523"
              small
              dark
              class="text-capitalize font-weight-bold app-btn-style"
              href="https://apps.apple.com/in/app/oh-yes-home-solution/id6471665769"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-icon left>mdi-apple</v-icon>
              App Store
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" md="2" class="pr-md-4">
          <h4 class="footer-heading">Quick Links</h4>
          <div class="d-flex flex-column">
            <v-btn
              text
              small
              v-for="item in menuItems"
              :key="item.title"
              @click="scrollTo(item.section)"
              class="footer-link-btn"
            >
              {{ item.title }}
            </v-btn>

          
          </div>
        </v-col>
        <v-col cols="6" md="3" class="pr-md-4">
          <h4 class="footer-heading">Quick Contact</h4>
          <div class="contact-info">
            <div class="mb-4">
              <v-icon color="#f46523" small class="mr-2">mdi-email</v-icon>
              <a href="mailto:support@ohyesworld.com" class="contact-link">
                support@ohyesworld.com
              </a>
            </div>
            <div class="mb-6">
              <v-icon color="#f46523" small class="mr-2">mdi-phone</v-icon>
              <a href="tel:+917034444303" class="contact-link font-weight-bold">
                +91 70344 44303
              </a>
            </div>

            <h4 class="footer-heading mb-3">Legal</h4>
            <v-btn text small class="footer-link-btn" style="margin-left: -8px">
              Terms & Conditions
            </v-btn>
            <v-btn text small class="footer-link-btn" style="margin-left: -8px">
              Privacy Policy
            </v-btn>
          </div>
        </v-col>

        <!-- Locations -->
        <v-col cols="12" md="3">
          <h4 class="footer-heading">Our Locations</h4>

          <div class="location-block mb-6">
            <h5 class="location-city">Kerala</h5>
            <p class="footer-text location-address">
              Oh yes Home Solutions, 2nd floor, spring field Avenue Elavoor,
              kavala, Angamaly, Kerala 683572
            </p>
          </div>

          <div class="location-block">
            <h5 class="location-city">Bengaluru</h5>
            <p class="footer-text location-address">
              Oh yes Home Solutions, Second floor, INQ Innovation, 59, 100 Feet
              Rd, Defence Colony, Indiranagar, Bengaluru, Karnataka 560038
            </p>
          </div>
        </v-col>
      </v-row>
      <v-divider class="my-8"></v-divider>
      <div class="text-center bottom-info">
        © {{ new Date().getFullYear() }} oh yes world. All Rights Reserved. |
        <span class="policy-link">Privacy Policy</span> |
        <span class="policy-link">Terms of Service</span>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",

  data() {
    return {
      menuItems: [
        { title: "About Us", section: "about" },
        { title: "Get Started", section: "services" },
        { title: "Contact Us", section: "contact" },
      ],
      socials: [
        {
          icon: "mdi-instagram",
          link: "https://www.instagram.com/ohyesappindia/",
        },
        {
          icon: "mdi-facebook",
          link: "https://www.facebook.com/ohyeservices?rdid=1qUf8auvEgMZGHxx&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1ChaAvTimm%2F#",
        },
        {
          icon: "mdi-linkedin",
          link: "https://www.linkedin.com/company/oh-yes-world-app/",
        },
        {
          icon: "mdi-youtube",
          link: "https://www.youtube.com/@ohyesappIndia",
        },
      ],
    };
  },

  methods: {
    scrollTo(section) {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.footer-text {
  color: black;
  line-height: 1.7;
  font-size: 14px;
}

.tagline-text {
  max-width: 350px;
  font-weight: 500;
}

.footer-heading {
  color: black;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
  border-left: 3px solid #f46523;
  padding-left: 8px;
  line-height: 1;
}

.footer-link-btn {
  text-transform: capitalize !important;
  justify-content: start;
  padding: 0 8px !important;
  margin-bottom: 4px;
  color: black !important;
  height: auto;
  min-height: 0;
  font-weight: 500;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-link-btn:hover {
  color: #f46523 !important;
  background-color: transparent !important;
}

.social-icon-btn {
  color: #000 !important;
  background-color: #eee;
  transition: all 0.3s ease;
  border-radius: 50%;
}

.social-icon-btn:hover {
  background-color: #f46523;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(244, 101, 35, 0.4);
}

.app-btn-style {
  background-color: #f46523 !important;
  border-radius: 6px;
  padding: 0 12px !important;
  height: 40px !important;
  min-width: 120px;
  transition: all 0.3s ease;
}

.app-btn-style:hover {
  background-color: #ff7a3b !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(244, 101, 35, 0.5);
}

.app-btn-style:hover {
  background-color: #333 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.contact-link {
  color: black;
  text-decoration: none;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #f46523;
}

.location-city {
  color: #000;
  font-weight: 700;
  font-size: 1.05rem;
  margin-bottom: 4px;
}

.location-address {
  font-size: 0.95rem;
  max-width: 250px;
}

.bottom-info {
  color: black;
  font-size: 0.9rem;
}

.policy-link {
  color: black;

  cursor: pointer;
  font-weight: 600;
  transition: color 0.3s;
}

.policy-link:hover {
  color: #f46523;
}
</style>
